<template>
    <div class="d-flex flex-column work-trips-wrapper">
        <div class="trip-list-scroll">
            <div
                v-for="trip in trips"
                :key="trip.id"
                :class="['trip-card', { 'trip-card-selected': selectedTripId === trip.id }]"
                :style="{ borderLeftColor: trip.color || '#ccc'}"
                @click="selectTrip(trip)"
                @mouseenter="hoverTrip(trip)"
                @mouseleave="hoverExit(trip)"
            >
                <div class="d-flex flex-row justify-content-between gap-1">
                    <div class="small">
                        <span class="fw-semibold me-2">{{ trip.license_plate }}</span>

                        <span class="text-muted">({{ trip.vehicle_owner }}) </span>

                        <span class="text-muted">- {{ trip.task }}</span>
                    </div>
                </div>

                <div class="small text-muted mt-2">
                    {{ trip.contract }}
                </div>

                <div class="d-flex justify-content-between gap-3 mt-3 small text-secondary">
                    <div class="small text-muted">
                        {{ toLocalTime(trip.start_time) }}
                    </div>

                    <div class="trip-info-row">
                        <span class="trip-info-item">
                            <font-awesome-icon
                                icon="road"
                                class="text-muted"
                            />
                            {{ formatDistance(trip.length) }} km
                        </span>

                        <span class="trip-info-item">
                            <font-awesome-icon
                                icon="clock"
                                class="text-muted"
                            />
                            {{ formatDurationFromTimes(trip.start_time, trip.end_time) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { timeUtils } from '../mixins/TimeUtils';

export default {
    name: 'VideoRecordingsList',
    mixins: [timeUtils],
    props: {
        trips: {
            type: Array,
            default: () => []
        },
        selectedTripId: {
            type: [Number, String],
            default: null
        }
    },
    emits: ['trip-selected', 'trip-hover', 'trip-hover-exit'],
    methods: {
        selectTrip(trip) {
            this.$emit('trip-selected', trip)
        },

        hoverTrip(trip) {
            this.$emit('trip-hover', trip)
        },

        hoverExit(trip) {
            this.$emit('trip-hover-exit', trip)
        },

        formatDate(dateString) {
            if (!dateString) return '-'

            const date = new Date(dateString)

            if (isNaN(date.getTime())) return '-'

            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')

            return `${day}.${month}.${year} klo ${hours}.${minutes}`
        },

        formatDistance(km) {
            if (km === null || km === undefined) return '0'
            return Number(km).toFixed(1)
        },

        formatDurationFromTimes(startTime, endTime) {
            if (!startTime || !endTime) return '0h 0min'

            const start = new Date(startTime)
            const end = new Date(endTime)

            const diffMs = end - start

            if (diffMs <= 0) return '0h 0min'

            const totalMinutes = Math.floor(diffMs / 60000)

            const h = Math.floor(totalMinutes / 60)
            const m = totalMinutes % 60

            return `${h}h ${m}min`
        }
    }
}
</script>

<style scoped>
.trip-list-scroll {
    flex: 1;
    overflow-y: auto;
    max-height: 50vh;
}

.trip-card {
    border-bottom: 0.5px solid #ccc;
    border-left: 4px solid #ccc;
    padding: .8em 1em;
    cursor: pointer;
    transition: background 0.15s ease;
}

.trip-card:hover {
    background: #f8f9fa;
}

.trip-info-row {
    display: flex;
    column-gap: 1.5rem;
    margin-right: .8em;
}

.trip-info-item {
    display: flex;
    align-items: center;
    gap: .5rem;
    width: 4.5rem;
    flex: 0 0 4.5rem;
    white-space: nowrap;
}

.trip-card-selected {
    background: #f3fae8;
    border-left-color: #7FC000 !important;
}

.work-trips-wrapper {
    height: 45vh;
}
</style>
